export enum EDocumentTypes {
  VERSION = 'VERSION', DEVVERSION = 'DEVVERSION', UNKNOWN = 'UNKNOWN'
}
